<!--故障台账列表 领导端-->
<template>
    <div class="faultList">
        <van-nav-bar
            title="故障台账"
            left-arrow
            @click-left="onClickLeft"
        >
            <template #right>
                <!-- 下拉选择 -->
                <van-dropdown-menu>
                    <van-dropdown-item
                        style="right:0"
                        v-model="curStation"
                        :options="stationList"
                        @change="search"
                    ></van-dropdown-item>
                </van-dropdown-menu>
            </template>
        </van-nav-bar>
        <div class="query-box">
            <div class="query-row">
                <span class="time-date" @click="chooseDate(0)">
                    <input v-model="queryDate[0]" readonly placeholder="选开始时间"><i class="iconfont iconxiala"></i>
                </span>
                <span class="split-line">—</span>
                <span class="time-date" @click="chooseDate(1)">
                    <input v-model="queryDate[1]" readonly placeholder="选结束时间"><i class="iconfont iconxiala"></i>
                </span>
                <van-search v-model="searchKey" placeholder="请输入司机/车牌号" @change="search"></van-search>
            </div>
            <van-dropdown-menu>
                <van-dropdown-item v-model="curCompany" :options="companyList" @change="search"></van-dropdown-item>
                <van-dropdown-item v-model="curAccentType" :options="accentTypeList" @change="search"></van-dropdown-item>
                <van-dropdown-item v-model="curStatus" :options="statusList" @change="search"></van-dropdown-item>
            </van-dropdown-menu>
        </div>
        <van-popup v-model="showTimeDatePop" position="bottom" :overlay="true">
            <van-datetime-picker
                v-model="datetime"
                type="year-month"
                title="选择年月"
                @confirm="confimDate"
                @cancel="showTimeDatePop = false"
            ></van-datetime-picker>
        </van-popup>
        <section>
            <van-pull-refresh
                class="warpper"
                v-model="refreshLoading"
                @refresh="onRefresh"
                v-if="dataList.length>0"
            >
                <van-list
                    v-model="loading"
                    :finished="finished"
                    :immediate-check="false"
                    @load="onLoad"
                    finished-text="没有更多了"
                >
                    <div
                        :class="['materialPlan-item', item.accidenttype===3?'status01':'']"
                        v-for="(item,index) in dataList"
                        :key="index"
                    >
                        <div :class="['corner-marker', item.status===1?'feedback-wcl':'feedback-other']">
                            <p class="text">
                                {{ status[item.status] }}
                            </p>
                        </div>
                        <ul>
                            <li class="tit">
                                <span class="pre-icon iconfont icontixing"></span>
                                <span class="info">
                                    {{ accentTypes[item.accidenttype] }}
                                    <template v-if="item.accidenttype===3">
                                        -{{ traffictypes[item.traffictype] }}
                                    </template>
                                </span>
                            </li>
                            <li class="name-length">
                                <span class="pre-icon material01"></span>
                                <span class="info">工程位置：{{ item.accident }}</span>
                            </li>
                            <li>
                                <span class="pre-icon material06"></span>
                                <span class="info">故障状态:{{ item.reportedtime }}</span>
                            </li>
                            <li>
                                <van-row>
                                    <van-col span="11">
                                        <span class="pre-icon material02"></span>
                                        <span class="info">车牌号:{{ item.licensenumber }}</span>
                                    </van-col>
                                    <van-col span="13">
                                        <span class="pre-icon material03"></span>
                                        <span class="info">车号:{{ item.carnumber }}</span>
                                    </van-col>
                                </van-row>
                            </li>
                            <li>
                                <van-row>
                                    <van-col span="11">
                                        <span class="pre-icon material04"></span>
                                        <span class="info">驾驶员:{{ item.driver }}</span>
                                    </van-col>
                                    <van-col span="13">
                                        <span class="pre-icon material05"></span>
                                        <span class="info">联系电话:{{ item.phone }}</span>
                                    </van-col>
                                </van-row>
                            </li>
                            <li>
                                <span class="pre-icon material06"></span>
                                <span class="info">报备时间:{{ item.reportedtime }}</span>
                            </li>
                        </ul>
                        <div class="btn-wrapper">
                            <span class="btn" @click="feedResult(item)">
                                反馈结果
                            </span>
                            <div class="line"></div>
                            <span class="btn" @click="handleView(item)">
                                查看
                            </span>
                        </div>
                    </div>
                </van-list>
            </van-pull-refresh>
            <div class="no_data" v-else></div>
        </section>
    </div>
</template>

<script>
import Utils from '@/utils/util.js';
export default {
    name: 'fault-list',
    beforeRouteLeave(to, from, next) {
        if (to.path === '/home') {
            this.$store.commit('noKeepAlive', 'fault-list');
        }
        next();
    },
    data() {
        return {
            refreshLoading: false,
            loading: false,
            finished: false,

            error: false,
            pageindex: 1,
            pagesize: 10,

            dataList: [],


            // 时间选择弹框
            showTimeDatePop: false,
            // 弹窗类型 0.开始时间，1结束时间
            timeDatePopIndex: 1,
            datetime: new Date(),
            // 搜索条件
            searchKey: '',
            // 查询日期
            queryDate: ['', ''],
            curStation: '',
            curCompany: '',
            curAccentType: '',
            curStatus: '',
            // 场站列表
            stationList: [],
            // 公司列表
            companyList: [{
                value: '',
                text: '全部',
            }],
            // 事故类型列表
            accentTypeList: [],
            // 状态列表
            statusList: [{
                value: '',
                text: '全部',
            }],
            status: {
                0: '新上报',
                1: '未处理',
                2: '已处理',
                3: '已办结',
            },
            accentTypes: {
                1: '车辆故障',
                2: '车辆超载',
                3: '交通事故',
                4: '其他',
            },
            traffictypes: {
                1: '我方责任',
                2: '对方责任',
                3: '双方责任',
            },
        };
    },
    created() {
        this.initPage();
    },
    methods: {
        // 初始化页面
        async initPage() {
            this.getStationList();
            await this.getCompanyList();
            this.getAccentTypeList();
            this.getStatusList();
            this.getList();
        },
        onLoad() {
            setTimeout(() => {
                this.pageindex += 1;
                this.loading = true;
                this.getList();
            }, 200);
        },
        // 搜索
        search() {
            this.pageindex = 0;
            this.finished = false;
            this.dataList = [];
            this.getList();
        },
        onRefresh() {
            this.pageindex = 0;
            this.finished = false;
            this.refreshLoading = true;
            this.dataList = [];
            this.getList();
        },

        getList() {
            const dto = {
                driver: this.searchKey, // 搜索关键字
                status: this.curStatus, // 状态
                station: this.curStation, // 场站
                company: this.curCompany, // 公司
                accidenttype: this.curAccentType, // 事故类型
                reportedtimebegin: this.queryDate[0],
                reportedtimeend: this.queryDate[1],
                pageindex: this.pageindex,
                pagesize: this.pagesize,
            };
            this.$axios
                .post('/interfaceApi/logistics/car_feedback/get_carfeedbacksbymanager', dto)
                .then(res => {
                    const rows = res.rows || [];
                    this.dataList.push(...rows);
                    if (this.dataList.length >= res.total) {
                        this.finished = true;
                    }
                    if (this.refreshLoading) {
                        this.refreshLoading = false;
                    }
                    this.loading = false;

                }) .catch(error => {
                    this.error = true;
                    this.loading = false;
                    this.errorText = error.ErrorCode.Message;
                });
        },
        // 选择时间
        chooseDate(index) {
            this.timeDatePopIndex = index;
            if (this.queryDate[index]) {
                this.datetime = new Date(this.queryDate[index]);
            }
            this.showTimeDatePop = true;
            this.search();
        },
        // 确认选择时间
        confimDate(val) {
            this.queryDate[this.timeDatePopIndex] = Utils.timeFormat(val, 'yyyy-MM-dd');
            this.showTimeDatePop = false;
        },
        // 反馈结果
        feedResult(item) {
            this.$router.isBack = 2;
            this.$router.push({
                name: 'feedbackResult',
                path: '/feedbackResult',
                params: {
                    canEdit: false,
                    data: item,
                },
            });
        },

        // 查看
        handleView(item) {
            this.$router.isBack = 2;
            this.$router.push({
                path: '/faultDetail',
                query: {
                    Id: item.Id,
                },
            });
        },
        // 拉取用户关联场站
        getStationList() {
            let stationIds = this.$takeTokenParameters('StationIds');
            if (stationIds) {
                stationIds = stationIds.split(',');
                const stationNames = this.$takeTokenParameters('StationNames').split(',');
                const stationList = stationIds.map((id, index) => {
                    return {
                        value: id,
                        text: stationNames[index],
                    };
                });
                this.stationList.push(...stationList);
                this.curStation = this.stationList[0].value;
            }
        },
        // 获取公司列表
        async getCompanyList() {
            const res = await this.$axios
                .get('/interfaceApi/logistics/car_feedback/get_car_companyoption');
            if (res.length > 0) {
                res.map(item => {
                    const obj = { value: item.id, text: item.name };
                    this.companyList.push(obj);
                });
                // this.curCompany = this.companyList[0].value;
            }
        },
        // 获取事故类型列表
        getAccentTypeList() {
            for (const key in this.accentTypes) {
                const obj = { value: key, text: this.accentTypes[key] };
                this.accentTypeList.push(obj);
            }
            this.curAccentType = this.accentTypeList[0].value;
        },
        // 获取状态列表
        getStatusList() {
            for (const key in this.status) {
                const obj = { value: key, text: this.status[key] };
                this.statusList.push(obj);
            }
        },
        // 返回上一页/右划回退
        onClickLeft() {
            this.$router.isBack = 1;
            this.$router.back();
        },

    },
};
</script>

<style lang="stylus" scoped>
.faultList
    height calc(100% - 44rpx)
    position relative
    background: #F0F0F0;
    >>> .van-nav-bar
        .van-dropdown-menu,
        .van-dropdown-menu__bar
            background none
            .van-dropdown-menu__title
                color #fff
    .query-box
        .query-row
            display flex;
            align-items center
            background #fff;
            padding 4rpx
            .split-line
                margin 0 1rpx;
            .time-date
                display flex
                align-items center
                width 90rpx;
                position relative
                input
                    font-size 12rpx;
                    border 0;
                    width 100%;
                    text-align center
                .iconxiala
                    font-size 12rpx;
                    position absolute
                    right 0
            >>> .van-search
                margin-left 2rpx
                padding 0
                flex 1;
                height auto;
                background transparent!important;
                .van-search__content
                    border-radius 4rpx;
                    border 1px solid #D7D7D7;
        >>> .van-dropdown-menu
                margin-top 1px;
                .van-dropdown-menu__bar
                    height 38rpx;
                    box-shadow none;
    .return-btn
        position absolute
        top 11rpx
        left 15rpx
        color #fff
        font-size 10rpx
        z-index 999
    section
        position: relative
        .warpper
            height calc(100% - 140rpx)
            background #F0F0F0
            overflow-y auto
            overflow-x hidden
            padding 0 12rpx 12rpx 12rpx
            .materialPlan-item
                &.status01
                    .icontixing
                        color #D6010F
                width 100%
                background #ffffff
                margin-top 15rpx
                position relative
                overflow hidden
                padding 12rpx
                color #666666
                font-size 14rpx
                li
                    overflow hidden
                    margin-bottom 10rpx
                    white-space nowrap
                    &.name-length
                        display flex
                        .info
                            flex 1
                    .icontixing
                        color #979EA7
                    .pre-icon
                        width 16rpx
                        height 16rpx
                        float left
                        background-size 100% 100%
                        background-repeat no-repeat
                        display inline-block
                        margin 2rpx 10rpx 0 0
                        &.material01
                            background-image url(../../../assets/images/icons/icon_gy_2.png)
                        &.material02
                            background-image url(../../../assets/images/icons/icon_gy_9.png)
                        &.material03
                            background-image url(../../../assets/images/icons/icon_18.png)
                        &.material04
                            background-image url(../../../assets/images/icons/icon_3.png)
                        &.material05
                            background-image url(../../../assets/images/icons/icon_4.png)
                        &.material06
                            background-image url(../../../assets/images/icons/icon_gy_7.png)
                    .info
                        float left
                    .info-bar
                        float left
                        width 125rpx
                        white-space nowrap
                        text-overflow ellipsis
                        overflow hidden
                    &.tit
                        font-size 18rpx
                        color #061F3E
                .feedback-wcl
                    background #D6010F
                .feedback-other
                    background #979EA7
                .corner-marker
                    width 60rpx
                    height 60rpx
                    position absolute
                    right -30rpx
                    top -30rpx
                    transform rotate(45deg)
                    -webkit-transform rotate(45deg)
                    -moz-transform rotate(45deg)
                    font-size 10rpx
                    text-align center
                    .text
                        position absolute
                        bottom 0.1rem;
                        padding 0
                        margin 0
                        color #fff
                        width 100%
                .btn-wrapper
                    border-top 2rpx solid #F0F0F0
                    padding-top 15rpx
                    display flex
                    justify-content space-around
                    align-items center
                    .line
                        width: 1px;
                        height: 15rpx
                        background: #D7D7D7;
                    .btn
                        width 80rpx;
                        height 30rpx
                        text-align center
                        border-radius 4rpx
                        display flex
                        justify-content center
                        align-items center
                        background #fff;
                        border 1px solid #5494F3
                        color #5494F3
</style>
